import { Stroke, Style, Fill } from 'ol/style';

/**
 * Generates OpenLayers styles for classified features (hexagons, DSP plots, etc.)
 * based on an array of RGBA color objects.
 *
 * @param {Array<{r: number, g: number, b: number, a: number}>|null} rgbColors
 * @returns {Style|Array<Style>} A single Style or array of Styles
 */
export const classificationStyles = rgbColors => {
	// If no colors are provided, return the default style
	if (!rgbColors || !rgbColors.length) {
		return new Style({
			stroke: new Stroke({
				color: `rgba(0,0,0,0.7)`,
				width: 2,
			}),
			fill: new Fill({
				color: `rgba(0,0,0,0.2)`,
			}),
		});
	}

	// If length is 1, return the style with the color
	if (rgbColors.length === 1) {
		const { r, g, b, a } = rgbColors[0];

		return new Style({
			stroke: new Stroke({
				color: `rgba(0,0,0,0.7)`,
				width: 2,
			}),
			fill: new Fill({
				color: `rgba(${r}, ${g}, ${b}, ${a})`,
			}),
		});
	}

	// Base style (stroke only, no fill)
	const styles = [
		new Style({
			stroke: new Stroke({
				color: `rgba(0,0,0,0.7)`,
				width: 2,
			}),
		}),
	];

	// Add style for each color provided
	rgbColors.forEach(function (rgbColor) {
		const { r, g, b, a } = rgbColor;

		styles.push(
			new Style({
				stroke: new Stroke({
					// Use the last color for the stroke
					color: 'rgba(0,0,0,0)',
					width: 2,
				}),
				fill: new Fill({
					color: `rgba(${r}, ${g}, ${b}, ${a})`,
				}),
			})
		);
	});

	return styles;
};
